import axiosInstance from "./global";
import CONFIG from "../../config";
import { saveAs } from "file-saver";
import { getQueryString } from "utils/utilFn";

const baseURL = `${CONFIG.BASE_URL}/auth-service/api/v1/admin`;

const baseUser = `${CONFIG.BASE_URL}/auth-service/api/v1/user`;
const basePayment = `${CONFIG.BASE_URL}/payment-gateway/api/v1`;
const baseSettlement = `${CONFIG.BASE_URL}/wayapay-identity-manager/api/v1`;
const baseBusiness = `${CONFIG.BASE_URL}/auth-service/api/v1/business`;
const dashboardUrl = `${CONFIG.BASE_URL}/auth-service/api/v1/dashboard`;
// const adminRoleUrl = `${CONFIG.BASE_URL}/wayapay-role-access/admin`;
// const adminRoleUrl1 = `${CONFIG.BASE_URL}/wayapay-role-access/admin`;
// const requestLogUrl = `${CONFIG.WAYABANK_URL}/activity-logservice`
const requestLogUrl = `${CONFIG.API_BASE_URL}/activity-logservice`;
// const baseIdentity = `${CONFIG.BASE_URL}/wayapay-identity-manager/api/v1`;

export const getUsers = async ({ page, size }) => {
  const queryString = getQueryString(page, size);
  return await axiosInstance
    .get(`${baseURL}/users/corporate-profile${queryString ?? ""}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log("err fetching");
      // throw new Error(err);
    });
};

export const getAllUsers = async ({ page, size }) => {
  const queryString = getQueryString(page, size);
  return await axiosInstance
    .get(`${baseURL}/users/corporate-profile${queryString ?? ""}`)
    .then((res) => res.data)
    .catch((err) => {
      console.log("err fetching");
      // throw new Error(err);
    });
};

export const getAllRequestLog = async ({ page, size }) => {
  return await axiosInstance
    .get(`${requestLogUrl}/api/v1/requestlog/list`)
    .then((res) => res.data)
    .catch((err) => {
      console.log("err fetching");
      // throw new Error(err);
    });
};

export const getAllStat = async () => {
  return await axiosInstance
    .get(`${requestLogUrl}/api/v1/requestlog/total-request`)
    .then((res) => res.data)
    .catch((err) => {
      console.log("err fetching");
      // throw new Error(err);
    });
};

export const createRequest = async (pojo) =>
  await axiosInstance
    .post(`${requestLogUrl}/api/v1/requestlog/create`, pojo)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 400) {
        return err.response.data;
      } else {
        // Handle else
      }
    });
export const UploadBulkRequest = ({ file }) => {
  let d = new Date();
  let reqId = d.getTime();
  let formData = new FormData();
  formData.append("file", file);
  formData.append("customerName", "Bulk Users");
  formData.append("requestId", d.getTime());
  formData.append("requestType", "createBulkMerchant");

  return axiosInstance
    .post(
      `${requestLogUrl}/api/v1/requestlog/create/bulk/${reqId}/Bulk Users/createBulkMerchant`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    )
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err.response.data.message);
    });
};

export const processRequest = (pojo) =>
  axiosInstance
    .post(`${requestLogUrl}/api/v1/requestlog/process-request `, pojo)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 400) {
        return err.response;
      } else {
        // Handle else
      }
    });

export const updateProcessor = ({ id, data }) =>
  axiosInstance
    .post(`${basePayment}/processors/${id} `, data)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 400) {
        return err.response;
      } else {
        // Handle else
      }
    });
export const toggleProcessor = ({ id, isActive }) =>
  axiosInstance
    .put(`${basePayment}/processors/${id}/enable?isActive=${isActive}`)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 400) {
        return err.response;
      } else {
        // Handle else
      }
    });
export const enableProcessor = ({ id, isActive, routingType }) =>
  axiosInstance
    .put(
      `${basePayment}/processors/routingType/${id}/enable?isActive=${isActive}&routingType=${routingType}`,
    )
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 400) {
        return err.response;
      } else {
        // Handle else
      }
    });
export const createUsers = (pojo) =>
  axiosInstance
    .post(`${baseURL}/users/create-corporate`, pojo)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 400) {
        return err.response.data;
      } else {
        // Handle else
      }
    });

export const getMerchant = async (userId) =>
  await axiosInstance
    .get(`${baseURL}/users/corporate-profile/merchantID/${userId}`)
    .then((res) => res.data)
    .catch((err) => console.log(err));

export const getAllAdminUsers = (page = 0, rowsPerPage = 10) =>
  axiosInstance
    .get(`${baseURL}/users?page=${page}&size=${rowsPerPage}`)
    .then((res) => res.data)
    .catch((err) => console.log(err));

export const getUserStatus = async () =>
  await Promise.all([
    axiosInstance.get(`${dashboardUrl}/active-users`),
    axiosInstance.get(`${dashboardUrl}/in-active-users`),
    axiosInstance.get(`${dashboardUrl}/total-registered-users`),
  ])
    .then((res) => res.map(({ data }) => data))
    .catch((err) => console.log(err));

export const UploadBulkUser = ({ file, isCorporate = true }) => {
  let formData = new FormData();
  formData.append("file", file);
  return axiosInstance
    .post(`${baseURL}/users/bulk-user-excel/${isCorporate}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

    .then((res) => res.data.data)
    .catch((err) => {
      throw new Error(err.response.data.message);
    });
};

export const UploadBulkUserDeactivate = ({ file, isCorporate = true }) => {
  let formData = new FormData();
  formData.append("file", file);
  return axiosInstance
    .post(`${baseURL}/users/bulk/account-deactivation`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

    .then((res) => res.data.data)
    .catch((err) => console.log(err));
};

export const deactivateUser = async (userId) =>
  await axiosInstance
    .post(`${baseURL}/users/activation-toggle?userId=${userId}`)
    .then((res) => res.data)
    .catch((err) => {
      throw new Error({ message: err });
    });

export const downloadTemplate = async ({ isCorporate }) => {
  await axiosInstance
    .get(`${baseURL}/download/bulk-user-excel?isCorporate=${isCorporate}`, {
      responseType: "arraybuffer",
    })
    .then((response) => {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "bulk-user-excel.xlsx");
    })
    .catch((err) => console.log(err));
};

export const getUniqueCell = ({ cellName, allData, uniqueCells = "city" }) => {
  if (typeof uniqueCells === "object") {
    return uniqueCells;
  }
  const keyArr = allData
    // eslint-disable-next-line
    ?.map((i) => eval(`i.${uniqueCells}`))
    ?.map((i) => i?.toUpperCase()?.trim());
  return [...new Set(keyArr)];
};

export const getUserById = (userId = "") =>
  axiosInstance
    .get(`${baseUser}/${userId}`)
    .then((res) => res.data.data)
    .catch((err) => {
      if (err.response.status === 400) {
        return err.response.data;
      } else {
        console.log(err);
        // Handle else
      }
    });

export const getMerchantById = async ({ userId }) =>
  await axiosInstance
    .get(`${baseURL}/users/corporate-profile/merchantID/${userId}`)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.status === 400) {
        return err.response.data;
      } else {
        console.log(err);
        // Handle else
      }
    });

export const getMerchantId = async (userId) =>
  await axiosInstance
    // .get(`${baseIdentity}/waya-merchant/${userId}`)
    .get(`${baseURL}/users/corporate-profile/merchantID/${userId}`)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.status === 400) {
        return err.response.data;
      } else {
        console.log(err);
        // Handle else
      }
    });

export const getMerchantWallet = async (userId) =>
  await axiosInstance
    .get(`${basePayment}/wallet/accounts/${userId}`)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.status === 400) {
        return err.response.data;
      } else {
        console.log(err);
        // Handle else
      }
    });

export const getMerchantAccounts = async (merchantId) =>
  await axiosInstance
    .get(
      `${baseSettlement}/waya-merchant/settlement-bank-account/fetch-all/admin/${merchantId}`,
    )
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.status === 400) {
        return err.response.data;
      } else {
        console.log(err);
        // Handle else
      }
    });

export const updateUser = ({ userId, updateData }) =>
  axiosInstance
    .put(`${baseURL}/update-profile/${userId}`, updateData)
    .then((res) => res.data.data)
    .catch((err) => {
      if (err.response.status === 400) {
        return err.response.data;
      } else {
        console.log(err);
        // Handle else
      }
    });

export const getBusinessType = async ({ page, size }) => {
  const queryString = getQueryString(page, size);
  return await axiosInstance
    .get(`${baseBusiness}/type/find/all${queryString ?? ""}`)
    .then((res) => res.data)
    .catch((err) => console.log(err));
};

export const getBusinessProfileById = async ({ userId }) => {
  return axiosInstance
    .get(`${baseURL}/users/corporate-profile/${userId}`)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.status === 400) {
        return err.response.data;
      } else {
        console.log(err);
        // Handle else
      }
    });
};
